import { lazy } from 'react';

const RELOAD_FLAG = 'wave-chunk-reload';

/**
 * React.lazy for a page. After a new deploy, a tab still running the old version asks for page
 * files that no longer exist; reload once to pick up the new version instead of showing an error.
 */
export default function lazyPage(load) {
    return lazy(() => load()
        .then((module) => {
            try {
                window.sessionStorage.removeItem(RELOAD_FLAG);
            } catch {
                // Storage unavailable; nothing to clear.
            }
            return module;
        })
        .catch((error) => {
            let alreadyReloaded = true;
            try {
                alreadyReloaded = window.sessionStorage.getItem(RELOAD_FLAG) === '1';
                if (!alreadyReloaded) window.sessionStorage.setItem(RELOAD_FLAG, '1');
            } catch {
                // Without storage we can't tell, so don't risk a reload loop.
            }
            if (error?.name === 'ChunkLoadError' && !alreadyReloaded) {
                window.location.reload();
                return new Promise(() => {}); // the page is reloading
            }
            throw error;
        }));
}
